/** Coerce API lang objects / arrays / primitives into a renderable string. */
export const toDisplayString = (value: unknown, lang = 'ru'): string => {
    if (value == null) return '';
    if (typeof value === 'string' || typeof value === 'number') return String(value);
    if (Array.isArray(value)) {
        const langKey = lang.slice(0, 2).toLowerCase();
        const localized = value.find(
            (item) => item?.lang?.slice?.(0, 2)?.toLowerCase() === langKey,
        )?.name;
        if (localized != null && localized !== '') return String(localized);
        const fallback = value.find((item) => item?.name != null && item?.name !== '')?.name;
        if (fallback != null) return String(fallback);
        return '';
    }
    if (typeof value === 'object' && value !== null && 'name' in value) {
        const name = (value as { name?: unknown }).name;
        if (typeof name === 'string' || typeof name === 'number') return String(name);
        return toDisplayString(name, lang);
    }
    return '';
};
/** Coerce API lang objects / arrays / primitives into a renderable string. */
export const toDisplayString = (value: unknown, lang = 'ru'): string => {
    if (value == null) return '';
    if (typeof value === 'string' || typeof value === 'number') return String(value);
    if (Array.isArray(value)) {
        const langKey = lang.slice(0, 2).toLowerCase();
        const localized = value.find(
            (item) => item?.lang?.slice?.(0, 2)?.toLowerCase() === langKey,
        )?.name;
        if (localized != null && localized !== '') return String(localized);
        const fallback = value.find((item) => item?.name != null && item?.name !== '')?.name;
        if (fallback != null) return String(fallback);
        return '';
    }
    if (typeof value === 'object' && value !== null && 'name' in value) {
        const name = (value as { name?: unknown }).name;
        if (typeof name === 'string' || typeof name === 'number') return String(name);
        return toDisplayString(name, lang);
    }
    return '';
};
